import { render, staticRenderFns } from "./GuppyChatMessagesList.vue?vue&type=template&id=6699bd83&"
import script from "./GuppyChatMessagesList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatMessagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports